/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */

// base imports
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';

// used helpers and components
import '../../../atoms/link/css/link';
import '../../../molecules/avatar/css/avatar';
import './my-profile-link.scss';
import './modifier/logged-in.scss';
